import {type ComponentProps, type ComponentRef, type RefObject} from 'react';
import {Button, ProgressBar} from 'components';

interface IInputFileProps extends Omit<ComponentProps<'input'>, 'children'> {
  inputRef: RefObject<ComponentRef<'input'> | null>;
  supportedFormats: string[];
  onUpload: (files: FileList) => void;
  buttonText?: string;
  loading?: boolean;
  progress?: number;
}

const InputFile = ({inputRef, supportedFormats, onUpload, buttonText = '+ Add file', loading = false, progress = 0, ...props}: IInputFileProps) => {
  return (
    <div className="p-5 py-10 sm:p-10 h-48 select-none flex flex-col justify-center items-center gap-5 border-2 border-dashed bg-whit border-slate-400 dark:border-gray-700 rounded-xl">
      <input ref={inputRef} name="file" type="file" className="hidden" onChange={e => onUpload(e.target.files as FileList)} {...props} />
      <Button text={buttonText} onClick={() => inputRef.current?.click()} loading={loading} />
      {!loading && (
        <div className="flex flex-col justify-center items-center gap-1.5">
          <p className="dark:text-white">Supported formats</p>
          <p className="text-sm text-gray-500">{supportedFormats.join(', ')}</p>
        </div>
      )}
      {loading && (
        <div className="mt-1.5 w-full flex flex-col justify-center items-center">
          <ProgressBar progress={progress} progressText="Uploading" />
          {progress >= 100 && <p className="text-slate-800 dark:text-darkText text-sm mt-1">Processing... please wait</p>}
        </div>
      )}
    </div>
  );
};

export default InputFile;
